import { create } from 'zustand'
import type { Domain } from '@/api/domains'

/** The domain currently selected (e.g. by clicking a card) — surfaced in the control plane. */
interface DomainSelectionState {
  selected: Domain | null
  select: (d: Domain | null) => void
}

export const useDomainSelection = create<DomainSelectionState>((set) => ({
  selected: null,
  select: (d) => set({ selected: d }),
}))

// The built-in system domain (code-defined; not a DB row) as a Domain-shaped object.
export const CRM_DOMAIN: Domain = {
  id: 'crm',
  name: 'crm',
  slug: 'crm',
  description: 'People & companies — the built-in system domain.',
  type: 'system',
  status: 'active',
  entity_types: ['person', 'company', 'event'],
  relation_types: ['knows', 'works_at', 'founder_of', 'member_of', 'invested_in', 'reports_to', 'had_interaction'],
}
